import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { newPageView } from '@/layouts'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: newPageView,
    meta: { title: '首页' },
    redirect: '/home',
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', keepAlive: true, icon: 'home' },
    },
    {
      path: '/leftMenuListPage',
      name: 'leftMenuListPage',
      component: () => import('@/views/leftMenuListPage/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/titleDetailPage',
      name: 'titleDetailPage',
      component: () => import('@/views/titleDetailPage/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/simpleDetailPage',
      name: 'simpleDetailPage',
      component: () => import('@/views/simpleDetailPage/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/recruitJobList',
      name: 'recruitJobList',
      component: () => import('@/views/recruitJobList/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/recruitJobDetail',
      name: 'recruitJobDetail',
      component: () => import('@/views/recruitJobDetail/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/videoList',
      name: 'videoList',
      component: () => import('@/views/videoList/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/videoPlay',
      name: 'videoPlay',
      component: () => import('@/views/videoPlay/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/resourceList',
      name: 'resourceList',
      component: () => import('@/views/resourceList/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/parallelListPage',
      name: 'parallelListPage',
      component: () => import('@/views/parallelListPage/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: () => import('@/views/questionnaire/index'),
      meta: { title: '', keepAlive: true, icon: 'home' },
    },

    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/user/login'),
    meta: { title: '首页', keepAlive: true, icon: 'home' },
  },
  {
    path: '/registerComUser',
    name: 'registerComUser',
    component: () => import('@/views/user/registerComUser'),
    meta: { title: '注册', keepAlive: true, icon: 'home' },
  },
  {
    path: '/registerUser',
    name: 'registerUser',
    component: () => import('@/views/user/registerUser'),
    meta: { title: '注册', keepAlive: true, icon: 'home' },
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/user/forgetPassword'),
    meta: { title: '找回密码', keepAlive: true, icon: 'home' },
  },
  {
    path: '/searchPage',
    name: 'searchPage',
    component: () => import('@/views/searchPage/index'),
    meta: { title: '', keepAlive: true, icon: 'home' },
  },

  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
